module.exports = __webpack_public_path__ + "img/oie-snaborder-produkt-01.jpg";